<ag-grid-angular #agGrid
                 class="agGrid ag-theme-quartz"
                 [context]="context"
                 [rowData]="glazingList"
                 [columnDefs]="columnDefs"
                 [autoGroupColumnDef]="autoGroupColumnDef"
                 [defaultColDef]="defaultColDef"
                 [sideBar]="sideBar"
                 [suppressDragLeaveHidesColumns]="suppressDragLeaveHidesColumns"
                 [rowGroupPanelShow]="rowGroupPanelShow"
                 (gridReady)="gridReady($event)"
                 (firstDataRendered)="onFirstDataRendered($event)"
                 [rowSelection]="rowSelection"
                 [statusBar]="statusBar"
                 [allowContextMenuWithControlKey]="true"
                 [getContextMenuItems]="glazingListContextMenu"
                 [initialGroupOrderComparator]="initialGroupOrderComparator"
                 (selectionChanged)="onSelectionChanged($event)"
                 (rowDoubleClicked)="onRowDoubleClicked($event)">
</ag-grid-angular>
